module.exports = __webpack_public_path__ + "static/cover-e844d02044bd3925ca7473503994e379.png";